module.exports = __webpack_public_path__ + "static/media/nextarrow_white.575d3e8e.svg";